module.exports = __webpack_public_path__ + "media/common/images/badges/active/vseznalek-c1d4f3a23219a9d28d13fb1845a63229.svg";